var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isPhoneDevice)?_c('router-view'):_c('PcTip',{attrs:{"qr-code":_vm.qrCodeUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }